import { render, staticRenderFns } from "./layout1.vue?vue&type=template&id=77c35671&scoped=true"
import script from "./layout1.vue?vue&type=script&lang=js"
export * from "./layout1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c35671",
  null
  
)

export default component.exports